import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';
import { ngxCsv } from 'ngx-csv/ngx-csv';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-assetto-task',
  templateUrl: './assetto-task.component.html',
  styleUrls: ['./assetto-task.component.css']
})
export class AssettoTaskComponent implements OnInit {

  i: any;
  deleteId: any;
  id: any;
  task: any = []
  tagUsersdropdownList = [];
  tagUsersselectedItems: any = [];
  tagUsersdropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'userId',
    textField: 'userName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };
  keyValueList: any = []
  ProductParams: any = []
  usersList: any = []
  assignInput = ""
  addClassType = ""
  statusNote = false;
  statusNoteText = ""
  userIdList = [];
  taskType = "All"
  pageNumber: number = 0;
  pageNumber1: number = 0;
  totalRecords: number = 0;
  recordsPerPage: number = 10;
  tableSize: number = 10;
  first: number = 0;
  taskMasters: any = []
  ticketId = ''
  ctid: any = "";
  TicketData: any = []
  imageSingle: any = ""
  videoSingle: any = ""
  vv: any = ""
  updatebutton: any = false
  showFilter: boolean = false

  tnotes = ""
  showAddNote: boolean = false
  t_Id: any
  editForm: any | FormGroup
  ttaskid: any
  taskPriority: any = "HIGH"
  countData: any = []
  priority_dropdown_toggle: boolean = false
  tpriority: any = "HIGH"
  excelData: any = []
  taskDetails_toggle: boolean = false
  updateDetails: any = ""
  downloadData: any = []
  isLoading: any = false;

  actionControls: any = {
    isAdd: false,
    isView: false,
    isDelete: false,
    isModify: false
  }

  constructor(private router: Router, private _sanitizer: DomSanitizer, private fb: FormBuilder, private toastr: ToastrService, private generic_service: GenericService) { }

  form: any | FormGroup
  modelSubtitle = false
  fileType: any;
  file = '';
  tasks: any = []
  images: any = [];
  videos: any = [];
  audios: any = [];
  name = ""
  description = ""
  assignedTo = ""
  searchFilter = ''
  taskId = ""
  note = ""
  taskStatus = ""
  taskCounts: any = {
    ALL: 0,
    NEW: 0,
    ASSIGNED: 0,
    REASSIGNED: 0,
    PENDING: 0,
    COMPLETED: 0,
    DEFERRED: 0,
    FORCE_CLOSED: 0,
    CLOSED: 0,
    WORK_IN_PROGRESS: 0,
    PARTIALLY_COMPLETED: 0,
  }

  totalTasks: Number = 0

  taskPercentage = ""
  task_active_or_inactive = "NEW"
  cid: any
  usersWithoutCustomers: any = []

  ngOnInit(): void {
    let href: any = window.location.href;
    let messages = href.split('/')
    let action: any = this.generic_service.checkActionControls(messages[messages.length - 1])
    this.actionControls = action

    this.cid = sessionStorage.getItem('cid')
    this.getUsers()
    this.getAllStatusCount()

    this.getUsersWithoutCustomers()
    this.getActiveOrInactiveTasks(this.task_active_or_inactive)
    this.form = this.fb.group({
      name: ['', [Validators.required]],
      description: [''],
      assignedTo: [''],
      tagUserIds: [''],
      taskExpStartDate: [''],
      taskExpEndDate: [''],
    });

    this.editForm = this.fb.group({
      name: ['', [Validators.required]],
      description: [''],
      assignedTo: [''],
      tagUserIds: [''],
      taskExpStartDate: [''],
      taskExpEndDate: [''],
      id: [''],
      taskId: [''],
    });
    this.getAllTaskCountForTechnician()
    this.getAllTaskNameAndDescription()
  }

  getParamByType() {
    this.generic_service.getParamByType('TASKPARAM').subscribe(
      (response: any) => {
        console.log(response);
        this.ProductParams = response.response;
        console.log(this.ProductParams);

        for (let i = 0; i < this.ProductParams.length; i++) {
          this.keyValueList.push(
            {
              "key": this.ProductParams[i].name,
              "value": "",
              "possibleValue": this.ProductParams[i].possibleValue
            }
          )
        }
        console.log(this.keyValueList);

      }
    )
  }

  getAllStatusCount() {
    this.generic_service.getAllStatusCount().subscribe(
      (res: any) => {
        console.log(res)

        for (let i = 0; i < res.response.length; i++) {
          if (res.response[i].status == 'ALL') {
            this.taskCounts.ALL = res.response[i].count
          }
          if (res.response[i].status == 'NEW') {
            this.taskCounts.NEW = res.response[i].count
          }
          if (res.response[i].status == 'ASSIGNED') {
            this.taskCounts.ASSIGNED = res.response[i].count
          }
          if (res.response[i].status == 'REASSIGNED') {
            this.taskCounts.REASSIGNED = res.response[i].count
          }
          if (res.response[i].status == 'PENDING') {
            this.taskCounts.PENDING = res.response[i].count
          }
          if (res.response[i].status == 'COMPLETED') {
            this.taskCounts.COMPLETED = res.response[i].count
          }
          if (res.response[i].status == 'DEFERRED') {
            this.taskCounts.DEFERRED = res.response[i].count
          }
          if (res.response[i].status == 'FORCE_CLOSED') {
            this.taskCounts.FORCE_CLOSED = res.response[i].count
          }
          if (res.response[i].status == 'CLOSED') {
            this.taskCounts.CLOSED = res.response[i].count
          }
          if (res.response[i].status == 'WORK_IN_PROGRESS') {
            this.taskCounts.WORK_IN_PROGRESS = res.response[i].count
          }
          if (res.response[i].status == "PARTIALLY_COMPLETED") {
            this.taskCounts.PARTIALLY_COMPLETED = res.response[i].count
          }
        }
        console.log(this.taskCounts)
        this.countData = []
        this.countData = res.response
      },
      (err: any) => {
        console.log(err)
      }
    )
  }


  getUsersWithoutCustomers() {
    this.generic_service.getUsersWithoutCustomers().subscribe(
      (res: any) => {
        this.usersWithoutCustomers = res.response;
      }
    )
  }

  getAllTaskCountForTechnician() {
    this.generic_service.getAllTaskCountForTechnician().subscribe(
      (response: any) => {
        console.log(response)
      },
      (error: any) => {

      }
    )
  }

  onTableDataChange(event: any) {
    this.pageNumber = event.page;
    this.pageNumber1 = event;
    this.first = event.first;

    if (
      this.filterDateChecked == true ||
      this.customerPhoneNoChecked == true ||
      this.filterByTaskIdChecked == true ||
      this.filterByTechnicianChecked == true ||
      this.filterByTaskPriorityChecked == true ||
      this.filterByTaskCompletedAndDatesChecked == true ||
      this.filterByTaskClosedAndDatesChecked == true ||
      this.filterStatusAndDateChecked == true ||
      this.filterByStatusAndUserIdAndDatesChecked == true
    ) {
      if (this.filterDateChecked) {
        this.taskFilterByCreatedBetweenDates(this.pageNumber, this.recordsPerPage, this.startDate, this.endDate)
      }
      if (this.customerPhoneNoChecked) {
        // this.getAllTicketsByCustomerPhoneNo(this.customerPhoneNo,this.pageNumber,this.recordsPerPage)
      }
      if (this.filterByTaskIdChecked) {
        this.getTaskById(this.filterByTaskId)
      }
      if (this.filterByTechnicianChecked) {
        this.taskFilterByAssignedTo(this.filterByTechnician, this.pageNumber, this.recordsPerPage)
      }
      if (this.filterByTaskPriorityChecked) {
        this.getAllTaskByTaskPriority(this.filterByTaskPriority, this.pageNumber, this.recordsPerPage)
      }

      if (this.filterByTaskClosedAndDatesChecked) {
        this.taskFilterByStatus(this.status, this.pageNumber, this.recordsPerPage)
      }

      if (this.filterByTaskCompletedAndDatesChecked) {
        this.taskFilterByStatus(this.status, this.pageNumber, this.recordsPerPage)
      }
      if (this.filterStatusAndDateChecked) {
        this.filterByTaskStatusAndBetweenDates(this.filterStatusDate, this.pageNumber, this.recordsPerPage, this.statusStartDate, this.statusEndDate)
      }
      if (this.filterByStatusAndUserIdAndDatesChecked) {
        this.filterTaskByStatusAndUserIdAndDates(this.userId, this.pageNumber, this.recordsPerPage, this.statusAndUserIdAndDates, this.fromDate, this.toDate)
      }
    } else {
      if (this.searchFilter != "") {
        this.getTaskByWildSearch(this.pageNumber, this.recordsPerPage)
      } else if (this.taskType == 'All') {
        this.getAllTask(Number(this.pageNumber), 10)
      }
      else if (this.taskType == 'Active') {
        this.getAllActiveTask(Number(this.pageNumber), 10)
      } else if (this.taskType == 'In-active') {
        this.getAllNonActiveTask(Number(this.pageNumber), 10)
      } else {
        this.getTasksByStatus(this.taskType)
      }
    }

  }


  onItemSelect(item: any) {
    console.log(item);
  }

  onSelectAll(items: any) {
    console.log(items);
  }

  getUsers() {
    this.generic_service.getUsers().subscribe(
      (res: any) => {
        this.usersList = res.response;
        this.tagUsersdropdownList = res.response;
        console.log(res);
      }
    )
  }

  addTask() {
    let tagUserIds = [];
    for (let i = 0; i < this.tagUsersselectedItems.length; i++) {
      tagUserIds.push(Number(this.tagUsersselectedItems[i].userId))
    }
    let status = ''
    if (this.form.get('assignedTo').value == '') {
      status = "NEW"
    } else {
      status = "ASSIGNED"
    }


    if (!this.form.valid) {
      this.toastr.error("please fill required fields");
      return
    }


    let body = {
      "version": 0,
      "isActive": true,
      "description": String(this.form.get('description').value),
      "taskRegType": "",
      "taskRegId": "",
      "taskSINumber": 0,
      "taskListingNumber": 0,
      "assignedTo": String(this.form.get('assignedTo').value),
      "taskExpStartDate": new Date(this.form.get('taskExpStartDate').value).getTime(),
      "taskExpEndDate": new Date(this.form.get('taskExpEndDate').value).getTime(),
      "taskActStartDate": 0,
      "taskActEndDate": 0,
      "taskExpDuration": 0,
      "taskActDuration": 0,
      "status": [
        {
          "note": "",
          "taskStatus": status,
          "updatedDate": 0
        }
      ],
      "completedPercentage": 0,
      "notes": "",
      "audio": this.audios,
      "video": this.videos,
      "image": this.images,
      "tagUserIds": tagUserIds,
      "name": String(this.form.get('name').value),
      "cid": this.cid
    }
    console.log(body)
    this.generic_service.addTask(body).subscribe(
      (response: any) => {
        console.log(response)
        this.getAllTask(this.pageNumber, this.recordsPerPage)
        this.clearForm()
        this.toastr.success(response.message);
        this.cancelModel()
      },
      (err: any) => {
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      }
    )
  }

  cancelModel() {
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
    document.getElementById("closeModalButton12")?.click()
    document.getElementById("closeModalButton6")?.click()
    document.getElementById("closeModalButton12")?.click()
    document.getElementById("closeModalButton44")?.click()

  }

  getAllTask(pageNumber: any, recordsPerPage: any) {
    this.pageNumber = pageNumber
    if (pageNumber == 0) {
      this.first = 0
    }
    this.taskType = "All"
    this.isLoading = true;

    this.generic_service.getAllTask(pageNumber, recordsPerPage).subscribe(
      (response: any) => {
        console.log(response)
        this.tasks = response.response.taskList;
        this.totalRecords = response.response.totalRecords
        this.isLoading = false;

      }
    )
  }

  addImageBtn() {
    document.getElementById("add-image-btn")?.click()
  }

  addVideoBtn() {
    document.getElementById("add-video-btn")?.click()
  }

  addAudioBtn() {
    document.getElementById("add-audio-btn")?.click()
  }

  editskill() {
    this.tasks[this.i].name = this.name
    this.tasks[this.i].description = this.description
    this.tasks[this.i].assignedTo = this.assignedTo;
    this.close()
  }

  open() {
    this.modelSubtitle = true;
  }

  close() {
    this.modelSubtitle = false;
    this.name = ""
    this.description = ""
    this.assignedTo = ""
  }

  edit(i: any) {
    this.open();
  }

  deleteTask() {
    this.generic_service.delTask(this.deleteId).subscribe(
      (res: any) => {
        this.toastr.success(res.message);
        this.getAllTask(this.pageNumber, this.recordsPerPage)
        this.cancelModel();
      }, err => {
        this.toastr.error(err.errors[0].description);
      }
    )
  }

  del(id: any) {
    this.deleteId = id
  }

  statusDropdown() {
    if (this.task[0].assignedTo == '' || this.task[0].assignedTo == null) {
      this.addClass('assignedTo')
    } else {
      if (this.statusNote == true) {
        this.statusNote = false;
      } else {
        this.statusNote = true;
      }
    }

  }
  taskAssignToUser(taskId: any, userId: any, taskStatus: any, name: string) {
    let note = "";
    note = "Task ASSIGNED to " + name;
    let body = {
      "taskId": Number(taskId),
      "userId": Number(userId),
      "taskStatusDTO": {
        "note": String(note),
        "taskStatus": String(taskStatus),
        "updatedDate": 0
      },
      "taskPriority": this.taskPriority
    }
    console.log(body)
    this.generic_service.taskAssignToUser(body).subscribe(
      (response: any) => {
        console.log(response);
        this.toastr.success(response.message);
        this.addClass('assignedTo')
        this.getSingleTask(taskId);
      },
      (error: any) => {
        this.toastr.error(error.error.errors[0].description);
        console.log(error)
      }
    )
  }



  updateStatus(taskId: any,) {
    this.updatebutton = true
    let body = {
      "note": String(this.note),
      "taskStatus": String(this.taskStatus),
      "updatedDate": 0,
      "images": this.images,
      "audios": [],
      "videos": []
    }
    console.log(body);
    this.generic_service.updateStatus(body, taskId).subscribe(
      (response: any) => {
        this.statusNote = false;
        this.getSingleTask(taskId);
        this.note = ''
        this.taskStatus = ""
        this.updatebutton = false
        console.log(response)
      },
      (error: any) => {
        console.log(error)
        this.toastr.error(error.error.errors[0].description)
        this.updatebutton = false
      }
    )
  }

  addClass(value: any) {
    console.log(value)
    if (this.addClassType == '') {
      let list = document.getElementById('assign-and-tag-data')
      if (list?.classList.contains('assign-show')) {
        list.classList.remove('assign-show')
        this.addClassType = ''
      } else {
        list?.classList.add('assign-show')
        this.addClassType = value
      }
    } else {
      if (this.addClassType == value) {
        let list = document.getElementById('assign-and-tag-data')
        if (list?.classList.contains('assign-show')) {
          list.classList.remove('assign-show')
          this.addClassType = ''
        } else {
          list?.classList.add('assign-show')
          this.addClassType = value
        }
      } else {
        this.addClassType = value
      }
    }
  }

  byStatus(status: any) {
    this.pageNumber = 0
    this.first = 0
    this.getTasksByStatus(status)
  }

  getTasksByStatus(status: any) {
    this.taskType = status;
    this.addClassType = '';
    console.log(status)
    this.isLoading = true;

    this.generic_service.getTasksByStatus(this.pageNumber, this.recordsPerPage, status).subscribe(
      (res: any) => {
        console.log(res)
        this.tasks = res.response.taskList;
        this.totalRecords = res.response.totalRecords;
        this.isLoading = false;

      },
      (err: any) => {
        console.log(err)
      }
    )
  }

  getTaskByWildSearch(pageNumber: any, recordsPerPage: any) {
    this.pageNumber = pageNumber
    this.first = pageNumber * recordsPerPage
    this.taskType = "All"
    this.isLoading = true;

    this.generic_service.getTaskByWildSearch(this.searchFilter, pageNumber, recordsPerPage).subscribe(
      (res: any) => {
        console.log(res)
        this.tasks = res.response.taskList;
        this.totalRecords = res.response.totalRecords;
        this.isLoading = false;
      },
      (err: any) => {
        console.log(err)
        this.isLoading = false;

      }
    )
  }

  refreshTickets() {
    this.showFilter = false

    this.pageNumber = 0
    this.first = 0
    this.task_active_or_inactive = "NEW"
    this.searchFilter = ""

    this.filterDateChecked = false
    this.customerPhoneNoChecked = false
    this.filterByTaskIdChecked = false
    this.filterByTechnicianChecked = false
    this.filterByTaskPriorityChecked = false
    this.filterByTaskCompletedAndDatesChecked = false
    this.filterByTaskClosedAndDatesChecked = false
    this.filterStatusAndDateChecked = false
    this.filterByStatusAndUserIdAndDatesChecked == false

    this.startDate = ""
    this.endDate = ""
    this.customerPhoneNo = ""
    this.filterByTaskId = ""
    this.filterByTechnician = ""
    this.filterByTaskPriority = ""

    this.filterByTaskCompletedAndDates = ""

    this.filterByTaskClosedAndDates = ""

    this.filterStatusDate = ""
    this.statusStartDate = ""
    this.statusEndDate = ""
    this.statusAndUserIdAndDates = ""
    this.userId = ""
    this.fromDate = ""
    this.toDate = ""
    this.getActiveOrInactiveTasks(this.task_active_or_inactive)
    this.getAllTaskNameAndDescription()
  }


  getSingleTask(id: any) {
    console.log(id)
    this.t_Id = id
    this.generic_service.getSingleTask(id).subscribe(
      (res: any) => {
        this.task = [];
        console.log(res);
        this.ticketId = res.response.ticketId
        this.ctid = res.response.ctid
        this.taskId = res.response.id;
        this.updateDetails = res.response.description

        // this.tpriority = res.response.tpriority
        this.task.push(res.response);
        if (this.ticketId != null && this.ticketId != null) {
          this.getSingleTicket(this.ticketId)
        }
        let arr: any = [];
        arr.push(Number(sessionStorage.getItem('userId')))
        let arr1: any = [];
        if (res.response.assignedTo != null && res.response.assignedTo != 0) {
          arr1.push(res.response.assignedTo)
        }
        if (res.response.tagUsers.length != 0) {
          for (let j = 0; j < res.response.tagUsers.length; j++) {
            arr.push(res.response.tagUsers[j].userid)
          }
        }
        let arr3 = arr.concat(arr1)
        this.userIdList = arr3
        this.userIdList = this.userIdList.filter((item, index) => this.userIdList.indexOf(item) === index);;
        console.log(this.userIdList)


        this.ttaskid = res.response.ttaskId
        this.editForm.patchValue({
          name: res.response.name,
          description: res.response.description,
          assignedTo: res.response.assignedTo,
          tagUserIds: res.response.tagUserIds,
          taskExpStartDate: res.response.taskExpStartDate,
          taskExpEndDate: res.response.taskExpEndDate,
          id: res.response.id,
          taskId: res.response.taskId,
        })
        console.log(this.editForm.value)
      }
    )



  }


  insertConversation() {
    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "id": 0,
      "conversationType": "TASK",
      "ticketTaskId": Number(this.taskId),
      "userIdList": this.userIdList,
      "remarks": "",
      "cid": this.cid
    }
    console.log(body)
    this.generic_service.insertConversation(body).subscribe(
      (response: any) => {
        console.log(response)
        this.toastr.success(response.message)
        this.cancelModel()
        this.router.navigateByUrl('/admin/create-user')

      },
      (err: any) => {
        console.log(err)
        this.toastr.error(err.error.errors[0].description)
        this.cancelModel()
        this.router.navigateByUrl('/admin/create-user')

      }
    )
  }

  taskStatusDropdown() {
    console.log(this.taskStatus)

    if (this.taskStatus == "WORK_IN_PROGRESS") {
      this.note = "Started working on this"
    }
    if (this.taskStatus == "COMPLETED") {
      this.note = "Complteed the task"
    }
    if (this.taskStatus == "PENDING") {
      this.note = "Moving to Pending"
    }
    if (this.taskStatus == "DEFERRED") {
      this.note = "Moving to deffered"
    }
    if (this.taskStatus == "PARTIALLY_COMPLETED") {
      this.note = "Partially completed the task"
    }
    if (this.taskStatus == "FORCE_CLOSED") {
      this.note = "Closing the task due to"
    }
    if (this.taskStatus == "CLOSED") {
      this.note = "Task Closed"
    }

  }

  updateTaskPercentage(percentage: any, taskId: any) {
    if (this.taskPercentage != percentage) {
      console.log(percentage)
      let body = {
        "taskId": Number(taskId),
        "taskPercentage": Number(percentage)
      }
      this.generic_service.updateTaskPercentage(body).subscribe(
        (response: any) => {
          console.log(response);
          this.getSingleTask(taskId)
        },
        (error: any) => {
          console.log(error)
        }
      )
    }
  }

  TaskPercentage(percentage: any) {
    this.taskPercentage = percentage
    console.log(this.taskPercentage)
  }

  clearForm() {
    this.tagUsersselectedItems = []
    this.images = [];
    this.videos = [];
    this.audios = [];
    this.form.reset()
  }

  searchclear() {
    this.searchFilter = ""
    this.getAllTask(this.pageNumber, this.recordsPerPage)
  }

  taskFilterByWildSearch(searchKey: any) {
    console.log(searchKey)
    console.log(searchKey.length)

    if (searchKey == "") {
      this.getAllTask(this.pageNumber, this.recordsPerPage)
    } else {
      this.isLoading = true;

      this.generic_service.taskFilterByWildSearch(searchKey).subscribe(
        (response: any) => {
          console.log(response)
          this.tasks = response.response;
          this.isLoading = false;

        },
        (error: any) => {
          console.log(error)
        }
      )
    }
  }
  getSingleTicket(id: any) {
    console.log(id)
    this.TicketData = []
    this.generic_service.getSingleTicket(id).subscribe(
      (res: any) => {
        this.TicketData = [];
        this.TicketData.push(res.response.ticket);

        console.log(this.TicketData)
      }
    )
  }

  viewImage(image: string) {
    this.videoSingle = ""
    this.vv = ""

    this.imageSingle = image
  }
  viewVideo(video: any) {
    this.imageSingle = ""
    this.videoSingle = video
    this.vv = this._sanitizer.bypassSecurityTrustResourceUrl(this.videoSingle);
  }

  onChange(event: any) {
    this.file = event.target.files[0];
    this.onUpload()
  }

  onUpload() {
    console.log(this.file);
    this.generic_service.uploadImage(this.file).subscribe((event: any) => {
      console.log(event);
      this.images.push(event.response)

    });
  }

  getActiveOrInactiveTasks(task: any) {
    this.pageNumber = 0;
    this.first = 0;
    if (task == 'All') {
      this.task_active_or_inactive = "All"
      this.getAllTask(this.pageNumber, this.recordsPerPage)
    }
    else if (task == 'Active') {
      this.task_active_or_inactive = "Active"
      this.getAllActiveTask(0, 10)
    } else if (task == 'In-active') {
      this.task_active_or_inactive = "In-active"
      this.getAllNonActiveTask(0, 10)
    } else {
      this.task_active_or_inactive = "NEW"
      this.getTasksByStatus(this.task_active_or_inactive)
    }
  }

  getAllActiveTask(pageNumber: any, recordsPerPage: any) {
    this.isLoading = true;

    this.generic_service.getAllActiveTask(pageNumber, recordsPerPage).subscribe(
      (res: any) => {
        console.log(res)
        this.tasks = res.response.taskList;
        this.totalRecords = res.response.totalRecords
        this.isLoading = false;

      }
    )
  }

  getAllNonActiveTask(pageNumber: any, recordsPerPage: any) {
    this.isLoading = true;

    this.generic_service.getAllNonActiveTask(pageNumber, recordsPerPage).subscribe(
      (res: any) => {
        console.log(res)
        this.tasks = res.response.taskList
        this.totalRecords = res.response.totalRecords
        this.isLoading = false;

      }
    )
  }

  toggleFilter() {
    this.showFilter = !this.showFilter
  }

  resetFilter() {
    this.filterDateChecked = false
    this.customerPhoneNoChecked = false
    this.filterByTaskIdChecked = false
    this.filterByTechnicianChecked = false
    this.filterByTaskPriorityChecked = false
    this.filterByTaskCompletedAndDatesChecked = false
    this.filterByTaskClosedAndDatesChecked = false
    this.filterStatusAndDateChecked = false
    this.filterByStatusAndUserIdAndDatesChecked == false
    this.selectedFilter = ""
    this.startDate = ""
    this.endDate = ""
    this.customerPhoneNo = ""
    this.filterByTaskId = ""
    this.filterByTechnician = ""
    this.filterByTaskPriority = ""

    this.filterByTaskCompletedAndDates = ""

    this.filterByTaskClosedAndDates = ""

    this.filterStatusDate = ""
    this.statusStartDate = ""
    this.statusEndDate = ""
    this.statusAndUserIdAndDates = ""
    this.userId = ""
    this.fromDate = ""
    this.toDate = ""
    this.selectedFilter = ""

    this.task_active_or_inactive = "NEW"
    this.getActiveOrInactiveTasks(this.task_active_or_inactive)
  }

  addNote() {
    let body =
    {
      "taskId": this.t_Id,
      "cid": Number(sessionStorage.getItem('cid')),
      "tnotes": {
        "slNo": 0,
        "note": this.tnotes,
        "userId": 0,
        "userName": "",
        "date": 0
      }
    }
    this.generic_service.updateTaskNotes(body).subscribe(
      (response: any) => {
        this.toastr.success(response.message)
        this.getSingleTask(this.t_Id)
        this.toggleNote()
        this.tnotes = ""
        console.log(response)
      },
      (error: any) => {
        console.log(error)
        this.toastr.error(error.error.errors[0].description)
      }
    )
  }

  toggleNote() {
    this.showAddNote = !this.showAddNote
  }

  priorityToggle() {
    this.priority_dropdown_toggle = !this.priority_dropdown_toggle
  }

  updateTaskPriority(taskPriority: any) {
    this.generic_service.updateTaskPriority(this.t_Id, taskPriority).subscribe(
      (response: any) => {
        this.toastr.success(response.message)
        this.getSingleTask(this.t_Id)
        this.priorityToggle()
        console.log(response)
      },
      (error: any) => {
        console.log(error)
        this.priorityToggle()
        this.toastr.error(error.error.errors[0].description)
      }
    )
  }


  dowuLoad() {

    this.excelData = []

    for (let i = 0; i < this.downloadData.length; i++) {
      let created: any = "";
      let assigned: any = "";
      let completed: any = "";

      for (let j = 0; j < this.downloadData[i].status.length; j++) {
        if (this.downloadData[i].status[j].taskStatus == "NEW") {
          created = formatDate(this.downloadData[i].status[j].updatedDate, 'EEEE, MMMM d, y, h:mm:ss a', 'en-US') + " " + this.downloadData[i].status[j].note
        }
        if (this.downloadData[i].status[j].taskStatus == "ASSIGNED") {
          assigned = formatDate(this.downloadData[i].status[j].updatedDate, 'EEEE, MMMM d, y, h:mm:ss a', 'en-US') + " " + this.downloadData[i].status[j].note
        }
        if (this.downloadData[i].status[j].taskStatus == "COMPLETED") {
          completed = formatDate(this.downloadData[i].status[j].updatedDate, 'EEEE, MMMM d, y, h:mm:ss a', 'en-US') + " " + this.downloadData[i].status[j].note
        }
      }

      let obj: any = {
        "Ticket Id": this.downloadData[i].ticketId,
        "Task Id": this.downloadData[i].taskId,
        "Created By User": this.downloadData[i].createdByUserName,
        "Created Date": formatDate(this.downloadData[i].createdDate, 'EEEE, MMMM d, y, h:mm:ss a', 'en-US'),
        "Name": this.downloadData[i].name,
        "Status": this.downloadData[i].latestTaskStatus,
        "Assigned To User Name": this.downloadData[i].assignedToUserName,
        "Assigned To Phone No": this.downloadData[i].assignedToPhoneNo,
        "Task Exp Start Date": formatDate(this.downloadData[i].taskExpStartDate, 'yyyy-MM-dd', 'en-US'),
        "Task Exp End Date": formatDate(this.downloadData[i].taskExpEndDate, 'yyyy-MM-dd', 'en-US'),
        "New": created,
        "Assigned": assigned,
        "Completed": completed,
      }

      this.excelData.push(obj)

    }

    console.log(this.excelData)


    let keys = Object.keys(this.excelData[0])

    var options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: false,
      showTitle: false,
      useBom: false,
      headers: keys
    };

    new ngxCsv(this.excelData, 'Report', options);
  }


  upDateTaskDetailsToggle() {
    this.taskDetails_toggle = !this.taskDetails_toggle
  }

  updateTaskDescription() {

    if (this.updateDetails == '') {
      this.toastr.error('description required')
      return
    }

    const body = {
      "description": this.updateDetails,
      "taskId": Number(this.t_Id),
      "cid": Number(this.cid)
    }

    this.generic_service.updateTaskDescription(body).subscribe(
      (response: any) => {
        this.toastr.success(response.message)
        // this.getTicketTaskByID(this.ticketId)
        this.getSingleTask(this.t_Id);

        this.upDateTaskDetailsToggle()
        console.log(response)
      },
      (error: any) => {
        console.log(error)
        this.upDateTaskDetailsToggle()
        this.toastr.error(error.error.errors[0].description)
      }
    )
  }





  filterDateChecked = false
  selectedFilter: any = ""
  startDate = ""
  endDate = ""
  customerPhoneNoChecked = false
  customerPhoneNo = ""
  filterByTaskIdChecked = false
  filterByTaskId = ""
  filterByTechnicianChecked = false
  filterByTechnician = ""
  filterByTaskPriorityChecked = false
  filterByTaskPriority = ""

  filterByTaskCompletedAndDatesChecked = false
  filterByTaskCompletedAndDates = ""

  filterByTaskClosedAndDatesChecked = false
  filterByTaskClosedAndDates = ""

  filterStatusAndDateChecked = false
  filterStatusDate = ""
  statusStartDate = ""
  statusEndDate = ""

  filterByStatusAndUserIdAndDatesChecked: any = false
  statusAndUserIdAndDates: any = ""
  userId: any = ""
  fromDate: any = ""
  toDate: any = ""

  filterStartDate: any
  status: any


  filterClicked(filter: any) {
    this.selectedFilter = filter

    this.filterDateChecked = false
    this.customerPhoneNoChecked = false
    this.filterByTaskIdChecked = false
    this.filterByTechnicianChecked = false
    this.filterByTaskPriorityChecked = false
    this.filterByTaskCompletedAndDatesChecked = false
    this.filterByTaskClosedAndDatesChecked = false
    this.filterStatusAndDateChecked = false
    this.filterByStatusAndUserIdAndDatesChecked = false

    if (filter == "filterDateChecked") {
      this.filterDateChecked = true
    }
    if (filter == "customerPhoneNoChecked") {
      this.customerPhoneNoChecked = true
    }
    if (filter == "filterByTaskIdChecked") {
      this.filterByTaskIdChecked = true
    }
    if (filter == "filterByTechnicianChecked") {
      this.filterByTechnicianChecked = true
    }

    if (filter == "filterByTaskPriorityChecked") {
      this.filterByTaskPriorityChecked = true
    }

    if (filter == "filterByTaskClosedAndDatesChecked") {
      this.filterByTaskClosedAndDatesChecked = true
      // this.status = "CLOSED"
    }

    if (filter == "filterByTaskCompletedAndDatesChecked") {
      this.filterByTaskCompletedAndDatesChecked = true
      // this.status = "COMPLETED"
    }

    if (filter == "filterStatusAndDateChecked") {
      this.filterStatusAndDateChecked = true
      // this.status = "COMPLETED"
    }

    if (filter == "filterByStatusAndUserIdAndDatesChecked") {
      this.filterByStatusAndUserIdAndDatesChecked = true
    }

  }


  applyFilter() {
    this.pageNumber = 0
    this.first = 0

    if (this.filterDateChecked) {
      this.taskFilterByCreatedBetweenDates(this.pageNumber, this.recordsPerPage, this.startDate, this.endDate)
      this.filterByCreatedBetweenDatesWithoutPagination(this.startDate, this.endDate)
    }
    if (this.customerPhoneNoChecked) {
      // this.getAllTicketsByCustomerPhoneNo(this.customerPhoneNo,this.pageNumber,this.recordsPerPage)
    }
    if (this.filterByTaskIdChecked) {
      this.getTaskById(this.filterByTaskId)
    }
    if (this.filterByTechnicianChecked) {
      this.taskFilterByAssignedTo(this.filterByTechnician, this.pageNumber, this.recordsPerPage)
      this.filterByAssignedToWithoutPagination(this.filterByTechnician)
    }
    if (this.filterByTaskPriorityChecked) {
      this.getAllTaskByTaskPriority(this.filterByTaskPriority, this.pageNumber, this.recordsPerPage)
      this.getAllTaskByTaskPriorityWithoutPagination(this.filterByTaskPriority)

    }

    if (this.filterByTaskClosedAndDatesChecked) {
      this.taskFilterByStatus(this.status, this.pageNumber, this.recordsPerPage)
      this.filterByTaskStatusAndBetweenDatesWithoutPagination(this.status, this.startDate, this.endDate)
    }

    if (this.filterByTaskCompletedAndDatesChecked) {
      this.taskFilterByStatus(this.status, this.pageNumber, this.recordsPerPage)
      this.filterByTaskStatusAndBetweenDatesWithoutPagination(this.status, this.startDate, this.endDate)

    }
    if (this.filterStatusAndDateChecked) {
      this.filterByTaskStatusAndBetweenDates(this.filterStatusDate, this.pageNumber, this.recordsPerPage, this.statusStartDate, this.statusEndDate)
      this.filterByTaskStatusAndBetweenDatesWithoutPagination(this.filterStatusDate, this.statusStartDate, this.statusEndDate)

    }
    if (this.filterByStatusAndUserIdAndDatesChecked) {
      this.filterTaskByStatusAndUserIdAndDates(this.userId, this.pageNumber, this.recordsPerPage, this.statusAndUserIdAndDates, this.fromDate, this.toDate)
      this.filterByStatusAndUserIdAndDatesWithoutPagination(this.userId, this.statusAndUserIdAndDates, this.fromDate, this.toDate)
    }

  }

  filterTaskByStatusAndUserIdAndDates(userId: any, pageNumber: any, recordsPerPage: any, status: any, fromDate: any, toDate: any) {
    fromDate = new Date(fromDate).getTime()
    toDate = new Date(toDate).getTime()
    this.isLoading = true;

    this.generic_service.filterTaskByStatusAndUserIdAndDates(userId, pageNumber, recordsPerPage, status, fromDate, toDate).subscribe(
      (response: any) => {
        console.log(response)
        this.tasks = response.response.taskList;
        this.totalRecords = response.response.totalRecords
        this.isLoading = false;

      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  filterByStatusAndUserIdAndDatesWithoutPagination(userId: any, status: any, fromDate: any, toDate: any) {
    fromDate = new Date(fromDate).getTime()
    toDate = new Date(toDate).getTime()
    this.generic_service.filterByStatusAndUserIdAndDatesWithoutPagination(userId, status, fromDate, toDate).subscribe(
      (response: any) => {
        console.log(response)
        this.downloadData = response.response;
      },
      (error: any) => {
        console.log(error)
      }
    )
  }


  filterByTaskStatusAndBetweenDates(status: any, pageNumber: any, recordsPerPage: any, statusStartDate: any, statusEndDate: any) {
    this.filterStartDate = new Date()
    let endDate: any = new Date(statusEndDate).getTime()
    let startDate = new Date(statusStartDate).getTime()
    let filterStatus = status
    this.isLoading = true;

    this.generic_service.filterByTaskStatusAndBetweenDates(pageNumber, recordsPerPage, filterStatus, startDate, endDate).subscribe(
      (res: any) => {
        console.log(res)
        this.tasks = res.response.taskList;
        this.totalRecords = res.response.totalRecords
        this.isLoading = false;

      }
    )
  }

  filterByTaskStatusAndBetweenDatesWithoutPagination(status: any, statusStartDate: any, statusEndDate: any) {
    this.filterStartDate = new Date()
    let endDate: any = new Date(statusEndDate).getTime()
    let startDate = new Date(statusStartDate).getTime()
    let filterStatus = status

    if (this.filterByTaskClosedAndDatesChecked) {
      this.filterStartDate.setDate(this.filterStartDate.getDate() - Number(this.filterByTaskClosedAndDates));
      startDate = new Date(this.filterStartDate).getTime()
      endDate = new Date().getTime()
      filterStatus = "CLOSED"
    }

    if (this.filterByTaskCompletedAndDatesChecked) {
      this.filterStartDate.setDate(this.filterStartDate.getDate() - Number(this.filterByTaskCompletedAndDates));
      startDate = new Date(this.filterStartDate).getTime()
      endDate = new Date().getTime()
      filterStatus = "COMPLETED"
    }

    this.generic_service.filterByTaskStatusAndBetweenDatesWithoutPagination(filterStatus, startDate, endDate).subscribe(
      (res: any) => {
        console.log(res)
        this.downloadData = res.response
      }
    )
  }


  // taskFilterByCreatedBetweenDates(pageNumber: any,recordsPerPage: any,status: any,startDate: any,endDate: any){
  //   this.generic_service.filterByTaskStatusAndBetweenDates(pageNumber,recordsPerPage,status,startDate,endDate).subscribe(
  //     (res:any)=>{
  //       console.log(res)
  //       this.tasks = res.response.taskList;
  //       this.totalRecords = res.response.totalRecords
  //     }
  //   )
  // }

  taskFilterByCreatedBetweenDates(pageNumber: any, recordsPerPage: any, startDate: any, endDate: any) {
    startDate = new Date(startDate).getTime()
    endDate = new Date(endDate).getTime()
    this.isLoading = true;

    this.generic_service.taskFilterByCreatedBetweenDates(pageNumber, recordsPerPage, startDate, endDate).subscribe(
      (response: any) => {
        console.log(response)
        this.tasks = response.response.taskList;
        this.totalRecords = response.response.totalRecords
        this.isLoading = false;

      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  filterByCreatedBetweenDatesWithoutPagination(startDate: any, endDate: any) {
    startDate = new Date(startDate).getTime()
    endDate = new Date(endDate).getTime()
    this.generic_service.filterByCreatedBetweenDatesWithoutPagination(startDate, endDate).subscribe(
      (response: any) => {
        console.log(response)
        this.downloadData = response.response.taskList;
      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  taskFilterByAssignedTo(userId: any, pageNumber: any, recordsPerPage: any) {
    this.isLoading = true;

    this.generic_service.taskFilterByAssignedTo(userId, pageNumber, recordsPerPage).subscribe(
      (res: any) => {
        console.log(res)
        this.tasks = res.response.taskList;
        this.totalRecords = res.response.totalRecords
        this.isLoading = false;

      }
    )
  }

  filterByAssignedToWithoutPagination(userId: any) {
    this.generic_service.filterByAssignedToWithoutPagination(userId).subscribe(
      (response: any) => {
        console.log(response)
        this.downloadData = response.response;
      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  taskFilterByStatus(status: any, pageNumber: any, recordsPerPage: any) {

    this.filterStartDate = new Date()
    let endDate: any = new Date(this.endDate).getTime()
    let startDate = new Date(this.startDate).getTime()
    let filterStatus = status

    if (this.filterByTaskClosedAndDatesChecked) {
      this.filterStartDate.setDate(this.filterStartDate.getDate() - Number(this.filterByTaskClosedAndDates));
      startDate = new Date(this.filterStartDate).getTime()
      endDate = new Date().getTime()
      filterStatus = "CLOSED"
    }

    if (this.filterByTaskCompletedAndDatesChecked) {
      this.filterStartDate.setDate(this.filterStartDate.getDate() - Number(this.filterByTaskCompletedAndDates));
      startDate = new Date(this.filterStartDate).getTime()
      endDate = new Date().getTime()
      filterStatus = "COMPLETED"
    }
    this.isLoading = true;

    this.generic_service.filterByTaskStatusAndBetweenDates(pageNumber, recordsPerPage, filterStatus, startDate, endDate).subscribe(
      (res: any) => {
        console.log(res)
        this.tasks = res.response.taskList;
        this.totalRecords = res.response.totalRecords
        this.isLoading = false;

      }
    )
  }

  getTaskById(filterByTasktId: any) {
    this.isLoading = true;

    this.generic_service.getSingleTask(filterByTasktId).subscribe(
      (res: any) => {
        console.log(res)
        this.tasks = [];
        this.tasks.push(res.response);
        this.totalRecords = 1
        this.isLoading = false;

      }
    )
  }

  getAllTaskByTaskPriority(taskPriority: any, pageNumber: any, recordsPerPage: any) {
    this.isLoading = true;

    this.generic_service.getAllTaskByTaskPriority(taskPriority, pageNumber, recordsPerPage).subscribe(
      (res: any) => {
        console.log(res)
        this.tasks = res.response.taskList;
        this.totalRecords = res.response.totalRecords
        this.isLoading = false;

      }
    )
  }

  getAllTaskByTaskPriorityWithoutPagination(taskPriority: any) {
    this.generic_service.getAllTaskByTaskPriorityWithoutPagination(taskPriority).subscribe(
      (res: any) => {
        console.log(res)
        this.downloadData = res.response.totalRecords
      }
    )
  }


  getAllTaskNameAndDescription() {
    this.generic_service.getAllTaskNameAndDescription().subscribe(
      (response: any) => {
        console.log(response)
        this.taskMasters = response.response
        console.log(this.taskMasters)

      }
    )
  }

  autoFill(taskName: any, taskDescription: any) {
    if (this.form && this.form.get('name')) {
      this.form.get('name').setValue(taskName);
      this.form.get('description').setValue(taskDescription);
    }
    if (this.editForm && this.editForm.get('name')) {
      this.editForm.get('name').setValue(taskName);
      this.editForm.get('description').setValue(taskDescription);
    }
    document.getElementById("closeModalButton")?.click();
    document.getElementById("closeModalButton33")?.click();
  }


  updatetask() {
    let tagUserIds = [];
    for (let i = 0; i < this.tagUsersselectedItems.length; i++) {
      tagUserIds.push(Number(this.tagUsersselectedItems[i].userId))
    }
    let status = ''
    if (this.editForm.get('assignedTo').value == '') {
      status = "NEW"
    } else {
      status = "ASSIGNED"
    }

    if (!this.editForm.valid) {
      this.toastr.error("please fill required fields");
      return
    }

    let body = {
      "taskId": this.taskId,
      "version": 0,
      "isActive": true,
      "description": String(this.editForm.get('description').value),
      "taskRegType": "",
      "taskRegId": "",
      "taskSINumber": 0,
      "taskListingNumber": 0,
      "assignedTo": String(this.editForm.get('assignedTo').value),
      "taskExpStartDate": new Date(this.editForm.get('taskExpStartDate').value).getDate(),
      "taskExpEndDate": new Date(this.editForm.get('taskExpEndDate').value).getDate(),
      "taskActStartDate": 0,
      "taskActEndDate": 0,
      "taskExpDuration": 0,
      "taskActDuration": 0,
      "status": [
        {
          "note": "",
          "taskStatus": status,
          "updatedDate": 0,
          "images": [],
          "audios": [],
          "videos": []
        }
      ],
      "completedPercentage": 0,
      "notes": "",
      "audios": [],
      "videos": [],
      "image": [],
      "tagUserIds": tagUserIds,
      "cid": this.cid,
      "name": String(this.editForm.get('name').value)
    }

    let body1 = {
      "taskId": Number(this.editForm.get('taskId').value),
      "version": this.task[0].version,
      "id": this.editForm.get('id').value,
      "isActive": this.task[0].isActive,
      "description": String(this.editForm.get('description').value),
      "taskSlNo": this.task[0].taskSlNo,
      "name": String(this.editForm.get('name').value),
      "taskRegType": this.task[0].taskRegType,
      "taskRegId": this.task[0].taskRegId,
      "taskSINumber": this.task[0].taskSINumber,
      "ticketId": this.task[0].ticketId,
      "taskListingNumber": this.task[0].taskListingNumber,
      "assignedTo": String(this.editForm.get('assignedTo').value),
      "taskExpStartDate": new Date(this.editForm.get('taskExpStartDate').value).getDate(),
      "taskExpEndDate": new Date(this.editForm.get('taskExpEndDate').value).getDate(),
      "taskActStartDate": this.task[0].taskActStartDate,
      "taskActEndDate": this.task[0].taskActEndDate,
      "taskExpDuration": this.task[0].taskExpDuration,
      "taskActDuration": this.task[0].taskActDuration,
      "status": this.task[0].status,
      "completedPercentage": this.task[0].completedPercentage,
      "notes": this.task[0].notes,
      "audio": this.task[0].audio,
      "video": this.images,
      "image": this.task[0].image,
      "tagUserIds": tagUserIds,
      "cid": Number(this.cid),





      "priorityNotification": this.task[0].priorityNotification,

      "branchId": this.task[0].branchId,
      "customerInvoiceId": this.task[0].customerInvoiceId,

      "latestTaskStatusDate": this.task[0].latestTaskStatusDate,
      "keyValueList": this.task[0].keyValueList,
      "ttnotes": this.task[0].ttnotes,
      "tpriority": this.task[0].tpriority,
      "ttaskId": this.task[0].ttaskId,
    }
    console.log(body1)
    this.generic_service.updateTask(body1).subscribe(
      (response: any) => {
        console.log(response)
        this.getAllTask(this.pageNumber, this.recordsPerPage);
        // this.getTaskTypeCount()
        this.clearForm()
        this.toastr.success("Successfully Updated");
        this.cancelModel()
      },
      (err: any) => {
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      }
    )
  }



  addTicketImageBtn() {
    document.getElementById("add-TicketImage-btn")?.click()
  }

  onTicketChange(event: any) {
    this.file = event.target.files[0];
    this.onTicketUpload()
  }

  onTicketUpload() {
    console.log(this.file);
    this.generic_service.uploadImage(this.file).subscribe((event: any) => {
      console.log(event);
      this.images.push(event.response)
      this.updateTicketPicture()
    });
  }

  updateTicketPicture() {
    let body = {
      "ticketId": this.TicketData[0].ticketId,
      "cid": Number(this.cid),
      "images": this.images
    }

    this.generic_service.updateTicketPicture(body).subscribe(
      (response: any) => {
        console.log(response)
        this.toastr.success("Successfully Updated");
        this.getSingleTicket(this.ticketId)

        this.images = []
      },
      (err: any) => {
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      }
    )
  }
}
